import store from '@/store';

export default async (to) => {
    await store.dispatch('page/FETCH_CURRENT_PAGE', _.get(to.params, 'pathMatch[0]', false));
};
